import React, { useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
    errorTexts,
    generalIcons,
    status,
    vanarExplorerUrl,
} from "../utils/constants";
import {
    getGasTiers,
    getTruncatedTrx,
} from "../utils/helper";
import { usePublicClient } from "wagmi";
import stakingAbi from "../blockchain/abi/staking.json";
import useChainId from "../hooks/useChainId";
import { useRootContext } from "../context/app-context";
import { handleButtons } from "../utils/buttons.helper";
import { executeContractWrite } from "../utils/wagmi.helper";
import { toast } from "react-toastify";
import { AddTrxToDB } from "../utils/firebase.helper";

function ConfirmStake({
    setIsTermsAgreed,
    inputValue,
    isConfirmDisabled,
    selectedValidator,
    userWalletAddress,
    setBtnloading,
    isMaxSelected,
    setTrxData,
    setTrx,
    setIsStakeAmountConfirmed,
    isStakeAmountConfirmed,
    btnloading,
}) {
    const inputRef = useRef(null);
    const { chainId } = useChainId();
    const { switchChainId, isSwitching } = useRootContext();
    const publicClient = usePublicClient();
    const currentStatus = localStorage?.getItem("trxStatus");
    const navigate = useNavigate()

    const Stake = async () => {
        // localStorage.setItem("trxStatus", status.PENDING);
        setBtnloading(true);

        let maxStakeAmount;
        if (isMaxSelected) {
            const gasTiers = await getGasTiers();
            const { tx_fee } = gasTiers?.data[0];
            const additionalFee = (tx_fee * 0.05) + tx_fee;
            maxStakeAmount = Math.floor((Number(inputValue) - (additionalFee + tx_fee)) * 100) / 100;
        }

        try {
            const data = {
                stakeContract: selectedValidator?.contract_address,
                amount: isMaxSelected ? maxStakeAmount : inputValue,
                tokenContractAbi: stakingAbi,
                userWalletAddress: userWalletAddress,
                action: "stake",
                publicClient,
            };

            const hash = await executeContractWrite(data);

            const obj = {
                t_hash: hash,
                type: status.STAKING,
            };

            // const trxDataObj = {
            //     txId: hash,
            //     from: userWalletAddress,
            //     txType: "Stake",
            //     to: selectedValidator?.contract_address,
            //     tvk: isMaxSelected ? maxStakeAmount : inputValue,
            // };

            // setTrxData(trxDataObj);

            toast.success(
                <>
                    <div className="flex items-center gap-4">
                        <span className="icon">{generalIcons.success}</span>
                        <div className="">
                            <h5>Hang tight—your transaction is surfing the blockchain waves!</h5>
                            <p>
                                Transaction ID:{" "}
                                <a
                                    href={`${vanarExplorerUrl}/tx/${hash}`}
                                    target="_blank"
                                    className="address"
                                    rel="noreferrer"
                                >
                                    {getTruncatedTrx(hash)}
                                </a>
                            </p>
                        </div>
                    </div>{" "}
                    <span></span>
                </>,
            );

            localStorage.setItem("trxData", JSON.stringify(obj));

            setTimeout(() => {
                setBtnloading(false);
                navigate("/my-account")
            }, 5000);

            // localStorage.setItem("trxData", JSON.stringify(obj));

            // setTrx(obj);
            // const db_data = {
            //     txId: hash,
            //     from: userWalletAddress,
            //     amount: Number(inputValue),
            //     txType: "Stake",
            //     status: "pending",
            //     to: selectedValidator?.contract_address,
            //     date: Math.floor(Date.now() / 1000),
            // };

            // AddTrxToDB(db_data);
        } catch (error) {
            if (error?.cause?.code) {
                toast.error(
                    <div className="flex items-center gap-4">
                        <span className="icon">{generalIcons.error}</span>
                        <div className="">
                            <p>{error?.shortMessage}</p>
                        </div>
                    </div>,
                );
            } else if (error?.shortMessage === errorTexts.gas_error) {
                toast.error(
                    <div className="flex items-center gap-4">
                        <span className="icon">{generalIcons.error}</span>
                        <div className="">
                            <p>{errorTexts.insufficient_funds_for_gas}</p>
                        </div>
                    </div>,
                );
            } else {
                toast.error(
                    <div className="flex items-center gap-4">
                        <span className="icon">{generalIcons.error}</span>
                        <div className="">
                            <p>{error?.shortMessage}</p>
                        </div>
                    </div>,
                );
            }
            setBtnloading(false);
            // localStorage.setItem("trxStatus", status.CANCELLED);
        }
    };

    return (
        <>
            {/* {isTrxSuccess && <TransactionSuccess />} */}
            <div className="flex items-center justify-center w-full h-auto xsm:h-full md:px-4 forMobile">
                <div className="max-w-[1200px] w-full bg-[#121212] border-[#1A1A1ACC] rounded-3xl pt-6 pb-11 md:py-10 px-4 md:px-9 mx-auto">
                    <div className="flex flex-col md:grid lg:grid-cols-2 gap-6 md:gap-8">
                        <div className="flex gap-3 md:gap-5">
                            <Link
                                className="flex items-center justify-center w-6 h-6 md:w-8 md:h-8 rounded-full bg-lightGray/[0.06] p-1"
                                onClick={() => {
                                    setIsStakeAmountConfirmed(false)
                                }}
                            >
                                {generalIcons.backArrow}
                            </Link>
                            <div className="flex flex-col gap-3">
                                <h4 className="text-textcolor text-xxl md:text-[34px] leading-none font-bold md:font-semibold capitalize">
                                    Review and confirm stake
                                </h4>
                                <p className="text-xsm md:text-sm font-normal text-dim/50 max-w-[390px]">
                                    Please review and confirm your stake. It may
                                    take some time for the transaction to be
                                    completed
                                </p>
                            </div>
                        </div>
                        <div className="">
                            <div className="bg-[#1A1A1A] border-[1.5px] border-white/[0.02] flex flex-col gap-3 md:gap-4 h-auto justify-between px-[18px] md:px-6 py-4 rounded-2xl w-full">
                                <div className="flex items-center justify-between">
                                    <h4 className="text-sm leading-6 text-dim/40 -tracking-03">
                                        Stake Amount
                                    </h4>
                                    <div className="relative w-[30%] flex justify-end">
                                        <div className="flex items-center">
                                            <div className="flex items-center justify-center w-5 h-5 mr-1">
                                                {generalIcons.vanry}
                                            </div>
                                            $VANRY
                                        </div>
                                    </div>
                                </div>
                                <div className="flex items-center justify-between gap-2">
                                    <input
                                        ref={inputRef}
                                        type="text"
                                        name="amount"
                                        className="text-[28px] font-semibold -tracking-08 leading-[30px] md:leading-[42px] cursor-default"
                                        placeholder="0"
                                        value={inputValue}
                                        autoComplete="off"
                                        readOnly
                                    />
                                </div>
                            </div>
                            <div className="mt-5 md:mt-[30px]">
                                {handleButtons(
                                    isConfirmDisabled,
                                    setIsStakeAmountConfirmed,
                                    chainId,
                                    switchChainId,
                                    isSwitching,
                                    Stake,
                                    isStakeAmountConfirmed,
                                    btnloading,
                                    currentStatus,
                                    false,
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ConfirmStake;
